import Scrollbar from 'smooth-scrollbar';
import { useEffect, useState } from 'react';
import Main from './Main/Main';
import Portfolio from './Portfolio/Portfolio';
import TrustedMe from './TrustedMe/TrustedMe';
import Contact from './Contact/Contact';
import Menu from './Menu/Menu';
import MovingCursor from './MovingCursor/MovingCursor';
import './App.css';

const App = () => {
	const [scrollbar, setScrollbar] = useState(undefined);

	useEffect(() => {
		const scrollbar = Scrollbar.init(document.querySelector('#my-scrollbar'), {
			damping: 0.08,
		});

		setScrollbar(scrollbar);
	}, []);

	return (
		<>
			<div className="app" id="my-scrollbar">
				<Menu scrollbar={scrollbar}></Menu>
				<Main scrollbar={scrollbar}></Main>
				<Portfolio scrollbar={scrollbar}></Portfolio>
				<TrustedMe></TrustedMe>
				<Contact></Contact>
			</div>
			<MovingCursor></MovingCursor>
		</>
	);
};

export default App;
